// extracted by mini-css-extract-plugin
module.exports =  {"btnWrapper":"btnWrapper___BSQm7","closeBtn":"closeBtn___6RC17","mobile":"mobile___6ZQ3N"};